import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteInfiniteScrollDirective } from './mat-autocomplete-infinite-scroll.directive';
import { CustomIdDirective } from './custom-id.directive';
import { ConfirmRedirectDirective } from './confirm-redirect.directive';
import { ConcreteBaseScrollingComponent } from '../_shared-components/base-scrolling-component/concrete-base-scrolling-component';

@NgModule({
  declarations: [
    CustomIdDirective,
    MatAutocompleteInfiniteScrollDirective,
    ConfirmRedirectDirective
  ],
  imports: [
    CommonModule
  ],
  exports:[
    CustomIdDirective,
    MatAutocompleteInfiniteScrollDirective,
    ConfirmRedirectDirective
  ],
  providers: [ConcreteBaseScrollingComponent]
})
export class DirectivesModule { }
